import { render, staticRenderFns } from "./dakaposter.vue?vue&type=template&id=0d461f58&"
import script from "./dakaposter.vue?vue&type=script&lang=js&"
export * from "./dakaposter.vue?vue&type=script&lang=js&"
import style0 from "./dakaposter.vue?vue&type=style&index=0&id=0d461f58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports